"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var monitoring_1 = require("../../services/monitoring");
var TAB_SELECTOR = ".tab";
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.refHandlers = {
            tablist: function (tabElement) { return (_this.tablistElement = tabElement); }
        };
        _this.renderTabPanel = function (tab) {
            var selectedTabId = _this.state.selectedTabId;
            var _a = tab.props, className = _a.className, panel = _a.panel, id = _a.id;
            if (panel === undefined) {
                return undefined;
            }
            var tabPanelId = _this.generateTabTitleId(_this.props.id, id);
            return (React.createElement("div", { "aria-labelledby": tabPanelId, "aria-hidden": id !== selectedTabId, className: classNames('tab__panel', className), id: tabPanelId, key: id, role: "tabpanel" }, panel));
        };
        _this.renderTabTitle = function (child) {
            var childProps = child.props;
            var selectedTabId = _this.state.selectedTabId;
            var title = childProps.title, children = childProps.children, disabled = childProps.disabled, id = childProps.id, selected = childProps.selected, className = childProps.className;
            return (React.createElement("div", { "aria-controls": _this.generateTabPanelId(_this.props.id, id), "aria-disabled": disabled, "aria-expanded": id === selectedTabId, "aria-selected": id === selectedTabId, className: classNames('tab', className), "data-tab-id": id, id: _this.generateTabTitleId(_this.props.id, id), onClick: disabled ? undefined : function (e) { return _this.handleTabClick(id, e); }, role: "tab", tabIndex: disabled ? undefined : 0 },
                title,
                children));
        };
        _this.updateSelectionIndicator = function () {
            if (_this.tablistElement === undefined || !_this.props.animate) {
                return;
            }
            // Find the selected tab element
            var tabIdSelector = TAB_SELECTOR + "[data-tab-id=\"" + _this.state.selectedTabId + "\"]";
            var selectedTabElement = _this.tablistElement.querySelector(tabIdSelector);
            // Calculate the updated indicator position styles
            var indicatorWrapperStyle = { display: 'none' };
            if (selectedTabElement != null) {
                var clientHeight = selectedTabElement.clientHeight, clientWidth = selectedTabElement.clientWidth, offsetLeft = selectedTabElement.offsetLeft, offsetTop = selectedTabElement.offsetTop;
                indicatorWrapperStyle = {
                    height: clientHeight,
                    transform: "translateX(" + Math.floor(offsetLeft) + "px) translateY(" + Math.floor(offsetTop) + "px)",
                    width: clientWidth
                };
            }
            _this.setState({ indicatorWrapperStyle: indicatorWrapperStyle });
        };
        _this.getTabElements = function (subselector) {
            if (subselector === void 0) { subselector = ''; }
            if (_this.tablistElement == null) {
                return [];
            }
            return _this.tablistElement.queryAll(TAB_SELECTOR + subselector);
        };
        _this.handleTabClick = function (newTabId, event) {
            _this.props.onChange
                ? _this.props.onChange(newTabId, _this.state.selectedTabId, event)
                : null;
            if (_this.props.selectedTabId === undefined) {
                _this.setState({ selectedTabId: newTabId });
            }
        };
        _this.tablistElement = null;
        _this.state = {
            indicatorWrapperStyle: { display: 'none' },
            selectedTabId: props.selectedTabId
        };
        return _this;
    }
    Tabs.prototype.componentDidMount = function () {
        monitoring_1.default('tabs');
        this.updateSelectionIndicator();
    };
    Tabs.prototype.componentWillReceiveProps = function (_a) {
        var selectedTabId = _a.selectedTabId;
        if (selectedTabId !== undefined) {
            this.setState({ selectedTabId: selectedTabId });
        }
    };
    Tabs.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) {
            this.updateSelectionIndicator();
        }
    };
    Tabs.prototype.render = function () {
        var _a = this.state, indicatorWrapperStyle = _a.indicatorWrapperStyle, selectedTabId = _a.selectedTabId;
        // Consolidate the Tab title elements
        var tabTitles = React.Children.map(this.props.children, function (child) {
            return this.renderTabTitle(child);
        }.bind(this));
        // Consolidate the Tab panel components
        var tabPanels = [];
        if (this.props.renderActiveTabPanelOnly) {
            tabPanels = this.getTabChildren()
                .filter(function (tab) {
                return tab.props.id === selectedTabId;
            })
                .map(this.renderTabPanel);
        }
        else {
            tabPanels = this.getTabChildren().map(this.renderTabPanel);
        }
        // Create the tab indicator
        var tabIndicator = this.props.animate ? (React.createElement("div", { className: "tab-indicator-wrapper", style: indicatorWrapperStyle },
            React.createElement("div", { className: "tab-indicator" }))) : (undefined);
        var classes = classNames('tabs', this.props.className);
        var tabListClasses = classNames('tabs-list', {
            'tabs-list--large': this.props.size === 'large'
        });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: tabListClasses, role: "tablist", ref: this.refHandlers.tablist },
                tabIndicator,
                tabTitles),
            tabPanels));
    };
    Tabs.prototype.getTabChildren = function (props) {
        if (props === void 0) { props = this.props; }
        return React.Children.toArray(props.children);
    };
    Tabs.prototype.generateTabTitleId = function (parentId, tabId) {
        return 'tab' + "-title_" + parentId + "_" + tabId;
    };
    Tabs.prototype.generateTabPanelId = function (parentId, tabId) {
        return 'tab__panel' + "_" + parentId + "_" + tabId;
    };
    Tabs.defaultProps = {
        animate: true
    };
    return Tabs;
}(React.Component));
exports.default = Tabs;
//# sourceMappingURL=Tabs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Tabs/Tabs.js
// module id = 210
// module chunks = 0